export const selectDocumentCreating = state => state.document.creating;
